module.exports = __webpack_public_path__ + "img/66000.e5be8aba.jpg";